__turbopack_context__.v({
  "buttonGroup": "PlpCrossLinking-module-scss-module__1coP8W__buttonGroup",
  "container": "PlpCrossLinking-module-scss-module__1coP8W__container",
  "cta": "PlpCrossLinking-module-scss-module__1coP8W__cta",
  "heading": "PlpCrossLinking-module-scss-module__1coP8W__heading",
  "navButton": "PlpCrossLinking-module-scss-module__1coP8W__navButton",
  "rail": "PlpCrossLinking-module-scss-module__1coP8W__rail",
  "root": "PlpCrossLinking-module-scss-module__1coP8W__root",
  "slide": "PlpCrossLinking-module-scss-module__1coP8W__slide",
  "swiper": "PlpCrossLinking-module-scss-module__1coP8W__swiper",
});
